/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgBattery32(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      fill='none'
      viewBox='0 0 32 32'
      {...props}
    >
      <path
        fill='currentColor'
        d='M18.553 1.28L17.483.22 12.66 5h3.531l-2.24 2.22 1.07 1.06 4.824-4.78h-3.532l2.24-2.22zM8.668 16.25V18H6.902v1.5h1.766v1.75h1.513V19.5h1.766V18H10.18v-1.75H8.668zM25.098 19.5h-5.045V18h5.045v1.5z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M11.694 8.5H6.145v3H2.11V32h27.78V11.5h-4.035v-3h-5.55v3h-8.61v-3zM28.377 13v10.75H3.623V13h24.754zm-4.036-3v1.5H21.82V10h2.522zm-14.16 1.5V10H7.66v1.5h2.522zm-6.558 19v-5.25h24.754v5.25H3.623z'
      />
    </svg>
  );
}

export default SvgBattery32;
